import { Fl44UnknownVolumePurchases } from '@/services/backend/products/fl44-unknown-volume/purchases';
import { Fl44UnknownVolumeContracts } from '@/services/backend/products/fl44-unknown-volume/contracts';
import { Fl44UnknownVolumeContractSupplementaryAgreements } from '@/services/backend/products/fl44-unknown-volume/supplementary-agreements';

export default {
    purchases: new Fl44UnknownVolumePurchases(),
    contracts: new Fl44UnknownVolumeContracts(),
    supplementaryAgreements: new Fl44UnknownVolumeContractSupplementaryAgreements()
};
